(function ($) {
    "use strict";

    const Maps = (function () {
        let map;
        let locationsMap;
        let infoWindow;
        let $header = $(".header");
        let $locationWrapper = $(".location__wrapper");

        /**
         * [init Initialise module]
         */
        const init = function () {
            _events();

            // create map
            $(".acf-map").each(function () {
                map = _new_map($(this));
            });

            // Locations map
            if ($("#map").length) {
                locationsMap = _new_map($("#map"));
            }
        };

        /**
         * [_events Bind event handlers]
         */
        const _events = function () {
            $("[data-js-marker-click]").on("click", function (e) {
                // e.preventDefault();
                const index = $(this).attr("data-marker-index");
                _markerClick(index);
                _scrollToMap();
            });
        };

        /**
         * [_markerClick Trigger click on marker]
         */
        const _markerClick = function (index) {
            google.maps.event.trigger(locationsMap.markers[index], "click");
        };

        /**
         * [_scrollToMap Scroll to map]
         */
        const _scrollToMap = function () {
            var headerHeight = 0;
            if (Modernizr.mq("only screen and (min-width: 768px)")) {
                var headerHeight = $header.height();
            }

            $.scrollTo($locationWrapper.offset().top - headerHeight, 200);
        };

        /**
         * [_new_map description]
         * @param  {[object]} $el        [jquery object]
         */
        const _new_map = function ($el) {
            const $markers = $el.find(".marker");
            const args = {
                zoom: 16,
                center: new google.maps.LatLng(0, 0),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                scrollwheel: false,
                streetViewControl: false,
                mapTypeControl: false,
            };
            const map = new google.maps.Map($el[0], args);
            infoWindow = new google.maps.InfoWindow();

            // add a markers reference
            map.markers = [];

            // add markers
            $markers.each(function () {
                _add_marker($(this), map);
            });

            // center map
            _center_map(map);

            // return
            return map;
        };

        const _add_marker = function ($marker, map) {
            const latlng = new google.maps.LatLng(
                $marker.attr("data-lat"),
                $marker.attr("data-lng")
            );
            let image = "";

            //the second half forces it to png for IE
            if (
                Modernizr.svg &&
                !(!!window.MSInputMethodContext && !!document.documentMode)
            ) {
                image = "/wp-content/themes/default/static/svg/pin.svg";
            } else {
                image = "/wp-content/themes/default/static/img/pin.png";
            }

            const marker = new google.maps.Marker({
                position: latlng,
                map: map,
                icon: image,
                size: new google.maps.Size(50, 50),
                scaledSize: new google.maps.Size(50, 50),
                animation: google.maps.Animation.DROP,
                optimized: false,
            });

            // add to array
            map.markers.push(marker);

            // if marker contains HTML, add it to an infoWindow
            if ($marker.html()) {
                // show info window when marker is clicked
                google.maps.event.addListener(marker, "click", function () {
                    map.setZoom(16);
                    map.setCenter(latlng);
                    infoWindow.setContent($marker.html());
                    infoWindow.close();
                    infoWindow.open(map, this);
                });
            }
        };

        const _center_map = function (map) {
            const bounds = new google.maps.LatLngBounds();

            // loop through all markers and create bounds
            $.each(map.markers, function (i, marker) {
                const latlng = new google.maps.LatLng(
                    marker.position.lat(),
                    marker.position.lng()
                );
                bounds.extend(latlng);
            });

            // only 1 marker?
            if (map.markers.length == 1) {
                // set center of map
                map.setCenter(bounds.getCenter());
                map.setZoom(16);
            } else {
                // fit to bounds
                map.fitBounds(bounds);
            }
        };

        return {
            init: init,
        };
    })();

    module.exports = Maps;
})(jQuery);
